// src/services/service.js

const isLocalhost =
  window.location.hostname.includes("localhost");

export const BASE_URL = 
// isLocalhost
  // ? "http://localhost:3001/api/exams"
  // : 
  "https://api.iskconsolapur.org/api/exams";

export default BASE_URL;